import { Fragment, useEffect, useState } from "react";

import { Combobox, ComboboxInput, ComboboxOption, ComboboxOptions, Transition } from "@headlessui/react";
import { CheckIcon, SelectorIcon } from "@heroicons/react/outline";

export default function ComboBoxMultipleInput({ label = "", options, searchField, valueField = "", register, setValue, registerName, defaultOption = false, initialValue = "" }) {
  const [selected, setSelected] = useState([]);
  const [query, setQuery] = useState('')


  //*   Example Usage   *//
  //   <ComboBoxMultipleInput
  //       label="Store Category"
  //       options={storeCategories.data!}
  //       searchField={"categoryName"}
  //       valueField="categoryId"
  //       register={register}
  //       setValue={handleCategoryChange}
  //       registerName={registerName}
  //       initialValue={categoryId as string | undefined}
  //     />

  //Search the options based on the name or the ID
  const filteredOptions =
    query === ''
      ? options
      : options.filter((option) =>
        option[searchField]
          .toLowerCase()
          .replace(/\s+/g, '')
          .includes(query.toLowerCase().replace(/\s+/g, ''))
        || option.id?.toString().includes(query)
      );

  // console.log(filteredOptions);

  const handleSelect = (selected) => {
    setSelected(selected);
    // console.log(option)
    if (valueField != "") {
      setValue(registerName, selected.map((option) => option[valueField]).join(', '));
    } else {
      setValue(registerName, selected.map((option) => option[searchField]).join(', '));
    }
  }

  useEffect(() => {

    if (defaultOption && options.length > 0) {
      // console.log(options)
      setSelected([options[0]]);
      // setValue(registerName, options[0])
    }

    if (initialValue && initialValue !== "") {
      //Take comma separated values and convert them to an array of options
      // console.log(initialValue)
      const initialOptions = initialValue.split(', ').map((value) => options.find(option => option[searchField]?.toLowerCase() === value?.toLowerCase() || option.id?.toLowerCase() === value?.toLowerCase()));
      // console.log(initialOptions)

      if (!initialOptions || initialOptions.length === 0 || initialOptions[0] === undefined) {
        // console.log('No options found')
      } else {
        setSelected(initialOptions);
        setValue(registerName, initialValue);
      }

    }
  }, [])

  // console.log(searchField, valueField, registerName, initialValue, selected)

  return (
    <div>
      {label &&
        <label>
          <span className="text-sm font-medium text-gray-500">{label}</span>
        </label>
      }
      <Combobox value={selected} onChange={handleSelect} multiple >
        <div className="relative mt-1">
          <div className="relative w-full cursor-default overflow-hidden bg-white text-left sm:text-sm ">
            <Combobox.Input
              className="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left focus:outline-none focus:ring-1 focus:ring-etpink-500 focus:border-etpink-500 sm:text-sm"
              displayValue={(options) =>
                options.map((option) => option[searchField] ?? "")?.join(', ')}
              onChange={(event) => setQuery(event.target.value)}
            />
            <Combobox.Button
              className="absolute inset-y-0 right-0 flex items-center pr-4 pl-8">
              <SelectorIcon
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </Combobox.Button>
          </div>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => setQuery('')}
          >
            <Combobox.Options className="absolute z-30 mt-1 max-h-60 w-full overflow-auto bg-white py-1 text-base rounded-b-md ring-1 ring-gray-400 ring-opacity-5 focus:outline-none sm:text-sm">
              {filteredOptions.length === 0 && query !== '' ? (
                <div className="relative cursor-default select-none py-2 px-4 text-gray-700">
                  Nothing found.
                </div>
              ) : (
                filteredOptions.slice(0, 100).map((option) => (
                  <Combobox.Option
                    key={option.id ?? option[searchField]}
                    className={({ active }) =>
                      `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? 'bg-etpink-600 text-white' : 'text-gray-900'
                      }`
                    }
                    value={option}
                  >
                    {({ selected, active }) => (
                      <>
                        <span
                          className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                            }`}
                        >
                          {option[searchField]}
                        </span>
                        {selected ? (
                          <span
                            className={`absolute inset-y-0 left-0 flex items-center pl-3 ${active ? 'text-white' : 'text-etpink-600'
                              }`}
                          >
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          </Transition>
        </div>
      </Combobox>
    </div>
  )
}